/* Список ключей local storage */
export enum LocalStorageKey {
  /** Ссылка для редиректа после авторизации */
  authRedirect = 'AUTH_REDIRECT',
}
